/**
 * DTO enum for extend direction when deleting project changes
 * Maps to backend ExtendDirectionDTO enum
 */
export enum ExtendDirectionDTO {
  PREVIOUS = 'PREVIOUS',
  NEXT = 'NEXT',
}

export type ExtendDirectionRequest = ExtendDirectionDTO;
export type ExtendDirectionResponse = ExtendDirectionDTO;
